export const ConstantsBengali = {
    patterns: [
        {
            //"search_word":"য়",
            //"replace_word":"y"
        },
        {
            //"search_word":"ড়",
            //"replace_word":"d"
        }
    ],
    //replacement while copying
    fix_patterns: [
        {
            "search_word":"য়",
            "replace_word":"য়"
        },
        {
            "search_word":"ড়",
            "replace_word":"ড়"
        },
        {
            "search_word":"ঢ়",
            "replace_word":"ঢ়"
        },
        {
            "search_word":"য়া",
            "replace_word":"য়া"
        },
        {
            "search_word":"ড়ো",
            "replace_word":"ড়ো"
        },
        {
            "search_word":"ঢ়ো",
            "replace_word":"ঢ়ো"
        },
        {
            "search_word":"ঢ়োঁ",
            "replace_word":"ঢ়োঁ"
        },
    ],
    variations:
    {
        // বিকল্প আখর আরু শব্দর তালিকা।
        //"মূলটো":"বিকল্পটো" (মূলটো আছে, বিকল্পে ইটোও শুদ্ধ -এই কনচেপ্ট।// থকাটো যিকোনো এফালে //দিব লাগিব)
        "র্ত্ত": "র্ত",
        "র্দ্দ": "র্দ",
        "র্য": "র্য্য",
		"র্য্য": "র্য",
        "য়": "য়",
        "য়": "য়",
        "ড়": "ড়",
        "ঢ়": "ঢ়",
        "র্ম্ম": "র্ম",
        "র্ব্ব": "র্ব",
        "ংগ": "ঙ্গ",
        "ঙ্ক": "ংক",
        "ঙ্ঘ": "ংঘ",
        "ঙ্খ": "ংখ",
		"‍্": ["্"],
		"ত্": ["ৎ"],
		"কো": "কো",
		"খো": "খো",
		"গো": "গো",
		"ঘো": "ঘো",
		"ঙো": "ঙো",
		"চো": "চো",
		"ছো": "ছো",
		"জো": "জো",
		"ঝো": "ঝো",
		"টো": "টো",
		"ঠো": "ঠো",
		"ডো": "ডো",
		"ঢো": "ঢো",
		"ণো": "ণো",
		"তো": "তো",
		"থো": "থো",
		"দো": "দো",
		"ধো": "ধো",
		"নো": "নো",
		"পো": "পো",
		"ফো": "ফো",
		"বো": "বো",
		"ভো": "ভো",
		"মো": "মো",
		"যো": "যো",
		"রো": "রো",
		"লো": "লো",
		"শো": "শো",
		"ষো": "ষো",
		"সো": "সো",
		"হো": "হো",
		"ক্ষো": "ক্ষো",
		"ড়ো": ["ড়ো"],
		"ঢ়ো": "ঢ়ো",
		"য়ো": "য়ো",
		"স্লো": ["স্লো"]
		

    },
    suggestion_replacement: {
        "খো": "খু",
		"খু": "খো",
		"চ": "ছ",
		"ছ": "চ",
        "ট": "ত",
        "ত": "ট",
        "ঠ": "থ",
        "থ": "ঠ",
        "ড": "দ",
        "দ": "ড",
        "ঢ": "ধ",
        "ধ": "ঢ",
        "ঢ়": "ঢ",
        "ড়": "ড",
        "ণ": "ন",
        "ন": "ণ",
        "জ": "য",
        "য়": "য",
        "য": "য়",
        " ি": "=ী",
        " ী": "=ি",
        " ু": "=ূ",
		"ঃ": ":",
		"এতকরফা": "একতরফা",
		"আভ্যন্তরীন": "অভ্যন্তরীণ",
		"রিটর্জ": "রিজৰ্ট",
		"মৌালিক": "মৌলিক",
		"ীয": "ীয়",
		"সহয়তা": "সহায়তা",
		"উত্তজনাপূর্ণ": "উত্তেজনাপূর্ণ",
		"উসকানি": "উস্কানি",
		"স্বান্ত্বনা": "সান্ত্বনা",
		"স্বত্বেও": "সত্ত্বেও",
		"স্বত্ত্বেও": "সত্ত্বেও",
		"ইচ্ছেমত": "ইচ্ছামত",
		"প্র্থী": "প্রার্থী",
		"কর্মমুখী": "কর্মমূখী",
		"অভ্যূত্থান": "অভ্যুত্থান",
		}
}